<template>
  <div>
    <BatteryDetail :key="batteryKey"></BatteryDetail>
  </div>
</template>

<script>
import BatteryDetail from "@/components/BatteryDetail/index.vue";
export default {
  components: {
    BatteryDetail,
  },
  data() {
    return {
      batteryKey: 1,
    };
  },
  watch: {
    "$route.params": {
      deep: true,
      immediate: true,
      handler(data, oldData) {
        if (data.id == oldData?.id) return;
        this.batteryKey += 1;
      },
    },
  },
};
</script>

<style></style>
